/**
 * @file 封装请求数据接口
 * @author quda
 */
import {jsonp, getParamsFromUrl, filterProps, makeSign} from '@baidu/map-fe-utils';

// interface IRequestConfig {
//     /**
//      * 接口地址
//      */
//     url: string;

//     /**
//      * 是否mock数据
//      */
//     isMock?: boolean;

//     /**
//      * 是否需要签名
//      */
//     needSign?: boolean;

//     /**
//      * md5盐值
//      */
//     salt?: string;

//     /**
//      * 服务接收签名参数的key值
//      * 默认为 sign
//      */
//      signKey?: string;

//     /**
//      * 参与签名的参数集合
//      */
//     signParams?: string[];
// }

// export type ITarget = string | IRequestConfig;

let phoneInfo = null;

export default (target, params = {}, option = {
    timeout: 10000
}) => {
    if (typeof target === 'string') {
        target = {
            url: target
        };
    }
    let url = target.url;

    if (!url) {
        throw new Error('[Error] request url is required!');
    }

    const isDev = process.env.NODE_ENV === 'development';
    const {isMock, salt = '', signKey = 'sign', signParams, needSign} = target;

    // Mock
    if (isDev && isMock) {
        const mockData = require('./mocks/index');
        const data = mockData.default[url];
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject({
                        errno: -3,
                        errmsg: '[ERROR] Time out.',
                        data: {}
                    });
                }
            }, 50);
        });
    }

    if (!phoneInfo) {
        phoneInfo = getParamsFromUrl();
    }

    const {cuid = '', os = '', sv = '', zid = ''} = phoneInfo || {};
    const reqParams = {
        cuid,
        os,
        sv,
        zid,
        ...params
    };

    if (needSign) {
        // 签名相关
        let p = null;
        signParams && (p = filterProps(reqParams, signParams));
        reqParams[signKey] = makeSign(p || params, salt);
    }

    return jsonp(url, reqParams, option);
};